module.exports = __webpack_public_path__ + "img/history-today.9379c578.png";